import React from 'react';


const GenuineProductIcon = () => (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="51px" height="51px" viewBox="0 0 51 51" enableBackground="new 0 0 51 51" xmlSpace="preserve">  <image id="image0" width="51" height="51" x="0" y="0"
    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAYAAAA6oTAqAAAABGdBTUEAALGPC/xhBQAAACBjSFJN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" />
  </svg>
);

export default GenuineProductIcon;
